import styled from 'styled-components';

const Divider = styled.hr.attrs(() => ({
  className: 'border-t-2 border-gray-800 my-6 px-4',
}))``;

export default Divider;